module.exports = __webpack_public_path__ + "static/media/summernote.82fa597f.ttf";